module.exports = __webpack_public_path__ + "img/thumb_16.931925c9.jpg";